// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1WHvB","head":"ProcedureTableInfo_head__3UQDa"};